import { useContext } from 'react';
import {
    MutationFunction,
    useMutation,
    UseMutationOptions,
} from '@tanstack/react-query';
import { useAPI } from '../lib/hooks';
import { AppContext } from '../sporttia/AppContext';

interface ImpersonateResponse {
    user: {
        id: number;
        role: string;
        status: string;
    };
}

export default function useImpersonateService() {
    const { migrationApis } = useContext(AppContext)!;
    const [request] = useAPI(migrationApis);

    function useValidateImpersonateToken(
        mutationOptions?: UseMutationOptions<
            ImpersonateResponse,
            unknown,
            { token: string }
        >,
    ) {
        const mutationFn: MutationFunction<
            ImpersonateResponse,
            { token: string }
        > = ({ token }: { token: string }) =>
            request('POST', '/manager/impersonate/validate-token', { token });

        return useMutation({
            mutationFn,
            ...mutationOptions,
        });
    }

    return { useValidateImpersonateToken };
}
